import React from 'react'
import DatePicker from 'react-datepicker';

const PickDate = (props) => {
    // Taken from https://stackoverflow.com/questions/53052012/set-timezone-react-datepicker
    // Basically adjusting the time to UTC -- so that the date always is correct,
    // even if current UTC date is different from our timezone date
    const formatUTC = (dateInt, addOffset = false) => {
        if (typeof dateInt === 'string') {
            return dateInt
        }
        if (dateInt === null) {
            // There should be note date. Put empty string in the form, but store null
            return addOffset ? '' : null
        }
        
        const date = (!dateInt || dateInt.length < 1) ? new Date() : new Date(dateInt)
        const offset = addOffset ? date.getTimezoneOffset() : -(date.getTimezoneOffset());
        const offsetDate = new Date();
        offsetDate.setTime(date.getTime() + offset * 60000)
        return offsetDate
    }
    
    const onChange = (date) => {
        const formatted = formatUTC(date)
        props.onChange(formatted)
    }
    
    let value = typeof props.value === 'undefined'
        ? ''
        : typeof props.value === 'string' 
            ? props.value === ''
                ? ''
                : new Date(props.value)
            : props.value
    return (<DatePicker
        selected={formatUTC(value, true)}
        onChange={onChange}
        disabled={props.disabled}
        popperPlacement="top"
        className="form-control"
        calendarStartDay={1}
        dateFormat="dd-MM-yyyy"
        placeholderText="DD-MM-YYYY"
    />
    )
}
export default PickDate
